<mat-sidenav-container
  class="mainWrapper"
  autosize
  autoFocus
  [ngClass]="{
    'sidebarNav-mini': options.sidenavCollapsed && options.navPos !== 'top' && !isOver,
    'sidebarNav-horizontal': options.horizontal,
    cardBorder: options.cardBorder,
    orange_theme: options.activeTheme == 'orange_theme',
    blue_theme: options.activeTheme == 'blue_theme',
    aqua_theme: options.activeTheme == 'aqua_theme',
    purple_theme: options.activeTheme == 'purple_theme',
    green_theme: options.activeTheme == 'green_theme',
    cyan_theme: options.activeTheme == 'cyan_theme'
  }"
  [dir]="options.dir!"
>
  <!-- ============================================================== -->
  <!-- Vertical Sidebar -->
  <!-- ============================================================== -->
  @if(!homePage && !options.horizontal) {
  <mat-sidenav
    #leftsidenav
    [mode]="sidenavMode"
    [opened]="isSidenavOpened"
    (openedChange)="onSidenavOpenedChange($event)"
    (closedStart)="onSidenavClosedStart()"
    class="sidebarNav"
  >
    <div class="flex-layout">
      <app-sidebar (toggleMobileNav)="sidenav.toggle()" [showToggle]="isOver"></app-sidebar>
      <ng-scrollbar class="position-relative" style="height: 100%">
        <mat-nav-list class="sidebar-list">
          @for(item of navItems(); track item) {
          <app-nav-item [item]="item" (notify)="sidenav.toggle()"> </app-nav-item>
          }
        </mat-nav-list>
      </ng-scrollbar>
    </div>
  </mat-sidenav>
  }

  <!-- ============================================================== -->
  <!-- Main Content -->
  <!-- ============================================================== -->
  <mat-sidenav-content class="contentWrapper" [ngClass]="{ 'homepage-content': homePage }" #content>
    <!-- ============================================================== -->
    <!-- VerticalHeader -->
    <!-- ============================================================== -->
    @if(!homePage) {
    <app-header
      [showToggle]="showDesktopToggle"
      (toggleCollapsed)="toggleCollapsed()"
      (toggleMobileNav)="sidenav.toggle()"
      (toggleMobileFilterNav)="filterNavRight.toggle()"
      (toggleAskPanel)="askPanel.toggle()"
      (optionsChange)="receiveOptions($event)"
      (onAppsLoaded)="apps.set($event)"
    ></app-header>
    } @if(homePage) {
    <!-- The Ask button sits outside the header's `homePage` gate, so it renders here too and
         its output has to be wired on this instance as well or the button is inert. -->
    <app-header
      [homePage]="true"
      (toggleAskPanel)="askPanel.toggle()"
      (optionsChange)="receiveOptions($event)"
    ></app-header>
    }

    <main
      class="pageWrapper position-relative"
      [ngClass]="{
        maxWidth: options.boxed
      }"
    >
      @if(!homePage) {
      <app-breadcrumb></app-breadcrumb>

      }
      <!-- ============================================================== -->
      <!-- Outlet -->
      <!-- ============================================================== -->

      <router-outlet></router-outlet>
    </main>
    <app-scroll-to-top [scrollContainer]="content"></app-scroll-to-top>
  </mat-sidenav-content>

  <mat-sidenav #customizerRight mode="over" position="end">
    <div class="p-x-16 p-y-20 d-flex align-items-center justify-content-between">
      <h3 class="mat-subtitle-1 f-s-21 f-w-600">Settings</h3>
      <button class="d-lg-none" mat-button (click)="customizerRight.toggle()">Close</button>
    </div>
    <mat-divider></mat-divider>

    <app-customizer (optionsChange)="receiveOptions($event)"></app-customizer>
  </mat-sidenav>
</mat-sidenav-container>

<!-- ------------------------------------------------------------------
  Ask help panel

  It gets its own drawer container, as a sibling of the main one.

  It cannot live in the main container: a MatDrawerContainer accepts exactly one drawer
  per side and `customizerRight` above already claims `position="end"`. A second end
  drawer there makes `_validateDrawers()` throw, which aborts `updateContentMargins()`
  and leaves the content wrapper with no sidebar margin — the content then sits
  underneath the sidebar and the header toolbar disappears behind it.

  A container-less drawer (how `filterNavRight` below is written) would also avoid the
  clash, but a drawer owned by a real container is the better home: the container is
  what supplies the backdrop, the click-outside-to-close and the focus trap.

  The container is a fixed, click-through overlay layer (see _container.scss), so it
  cannot affect the main shell: with the panel closed, the layout is exactly as on main.
  ------------------------------------------------------------------ -->
<mat-drawer-container class="askPanel-container" [dir]="options.dir!">
  <mat-drawer
    #askPanel
    mode="over"
    position="end"
    class="askPanel-drawer"
    (openedStart)="onAskPanelOpenedStart()"
    (openedChange)="onAskPanelOpenedChange($event)"
  >
    <!-- Only built once the panel is first opened, so nothing is fetched at app boot. -->
    @if(askPanelInitialized()) {
    <app-ask-panel [opened]="askPanelOpened()" (closePanel)="askPanel.close()"></app-ask-panel>
    }
  </mat-drawer>
</mat-drawer-container>

<!-- ------------------------------------------------------------------
  Mobile Apps Sidebar
  ------------------------------------------------------------------ -->
<mat-drawer #filterNavRight mode="over" position="end" class="filter-sidebar">
  <div>
    <div class="d-flex justify-content-between align-items-center">
      <div class="branding">
        @if(options.theme === 'light') {
        <a [routerLink]="'/'">
          <img src="assets/images/logos/logo.svg" class="align-middle m-2" alt="logo" />
        </a>
        } @else {
        <a [routerLink]="'/'">
          <img src="assets/images/logos/logo.svg" class="align-middle m-2" alt="logo" />
        </a>
        }
      </div>
      <button mat-icon-button (click)="filterNavRight.toggle()" class="d-flex justify-content-center">
        <i-tabler name="x" class="icon-18 d-flex"></i-tabler>
      </button>
    </div>

    <mat-accordion>
      <mat-expansion-panel class="shadow-none">
        <mat-expansion-panel-header>
          <mat-panel-title class="f-s-16 f-w-500"> {{ "Apps" | translate }} </mat-panel-title>
        </mat-expansion-panel-header>
        <div>
          <div class="row">
            @for(appdd of apps(); track appdd.img) {
            <div class="col-12 text-hover-primary">
              <a [href]="appdd.link" class="d-flex align-items-center text-decoration-none m-b-24 gap-16">
                <button mat-mini-fab class="text-primary bg-light-primary shadow-none rounded">
                  <img [src]="appdd.img" width="20" />
                </button>

                <div>
                  <h5 class="f-s-14 f-w-600 m-0 textprimary mat-body-1 hover-text">
                    {{ appdd.title }}
                  </h5>
                  <span class="mat-body-1 f-s-12">{{ appdd.subtitle }}</span>
                </div>
              </a>
            </div>
            }
          </div>
          <!-- <h4 class="f-s-18 f-w-600 mat-subtitle-1 m-b-16">Quick Links</h4>
          @for(quicklink of quicklinks; track quicklink.title) {
          <div class="text-hover-primary">
            <a
              [routerLink]="['quicklink.link']"
              class="hover-text text-decoration-none mat-body-1 f-w-600 d-block p-y-8"
              >{{ quicklink.title }}</a
            >
          </div>
          } -->
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
</mat-drawer>
